import { render } from "./OtpStep.vue?vue&type=template&id=36a959d0&scoped=true"
import script from "./OtpStep.vue?vue&type=script&lang=js"
export * from "./OtpStep.vue?vue&type=script&lang=js"

import "./OtpStep.vue?vue&type=style&index=0&id=36a959d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a959d0"],['__file',"src/views/components/OtpStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36a959d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36a959d0', __exports__)) {
    api.reload('36a959d0', __exports__)
  }
  
  module.hot.accept("./OtpStep.vue?vue&type=template&id=36a959d0&scoped=true", () => {
    api.rerender('36a959d0', render)
  })

}


export default __exports__